import { Provider } from '@pricemoov/pollux-react';

import { useAuthManager } from './contexts/AuthManager';

function PolluxProvider({ children }) {
    const { authData } = useAuthManager();
    return <Provider locale={authData?.user?.language}>{children}</Provider>;
}

export default PolluxProvider;
